const { VALIDATION_ERRORS, VALIDATION_WARNINGS } = require("../validationErrors");
const Countries = require("senter-countries");
class ContactValidator {
  constructor(userCountries) {
    this._validators = [
      new PhoneNumberCountryCodeValidator(userCountries),
      new PhoneNumberValidator(),
      new FirstNameFormatValidator(),
      new LastNameFormatValidator()
    ];
  }
  validate(contact) {
    var errors = [];
    this._validators.forEach(v => {
      var error = v.validate(contact);
      if (error) errors.push(error);
    });
    return errors;
  }
}

class PhoneNumberCountryCodeValidator {
  constructor(userCountries) {
    this._userCountries = userCountries;
  }
 

  validate(contact) {    
    if (!contact.phoneNumber.code) {
      return VALIDATION_ERRORS.INVALID_COUNTRY_CODE;
    }    
    if (      
      !Countries.isAllowedCode(
        this._userCountries,
        contact.phoneNumber.code
      )
    ) {
      return VALIDATION_ERRORS.COUNTRY_CODE_NOT_ALLOWED;
    }

    return null;
  }
}

class FirstNameFormatValidator {

  constructor(){
    this._regexToGetNames = /\p{L}+'?\p{L}+/gu;
    this._regexAllCapitalOrAllLowercase = /^(\p{Lu}+|\p{Ll}+)$/gu;
  }

  validate(contact) {
    if (contact.firstName) {
      var isInvalid = false;
      var match = contact.firstName.match(this._regexToGetNames)
      if (match){
        match.forEach(name => {
            if (name.match(this._regexAllCapitalOrAllLowercase)) 
                isInvalid = true;
        });
      }
      if (isInvalid) {
        return VALIDATION_WARNINGS.WARNING_INVALID_FIRST_NAME_FORMAT;
      }
    }
    return null;
  }
}
class LastNameFormatValidator {
 
  constructor(){
    this._regexToGetNames = /\p{L}+'?\p{L}+/gu;
    this._regexAllCapitalOrAllLowercase = /^(\p{Lu}+|\p{Ll}+)$/gu;
  }
  validate(contact) {
    if (contact.lastName) {
        var isInvalid = false;
        var match = contact.lastName.match(this._regexToGetNames);
        
        if (match){
            match.forEach(name => {
                if (name.match(this._regexAllCapitalOrAllLowercase)) 
                isInvalid = true;
            });
        }
        if (isInvalid) {
          return VALIDATION_WARNINGS.WARNING_INVALID_LAST_NAME_FORMAT;
        }
      }
    return null;
  }
}

class PhoneNumberValidator {

  constructor(){
    this._regex_NZ = /^2\d{7,9}$/
    this._regex_AU = /^[45]\d{8}$/
    this._regex_IE = /^(8[35679])\d{7,9}$/
    this._regex_UK = /^\d{9,10}$/
  }
  validate(contact) {
    var _regex;
    if  (!contact.phoneNumber.number){
      return VALIDATION_ERRORS.INVALID_PHONE_NUMBER
    }

    switch (contact.phoneNumber.code)
    {
      case '64':
        _regex = this._regex_NZ
        break
      case '61':
        _regex = this._regex_AU
        break
      case '353':
        _regex = this._regex_IE
        break
      case '41':
        _regex = this._regex_UK
        break
      default:
        return
    }

    if ( !contact.phoneNumber.number.match(_regex)) {
      return VALIDATION_ERRORS.INVALID_PHONE_NUMBER
    }

    return null;
  }
}

module.exports = { VALIDATION_ERRORS, ContactValidator, PhoneNumberValidator };
